import { IonButton, IonItem, IonLabel, IonNote, useIonAlert, useIonViewWillEnter } from '@ionic/react';
import React from 'react'
import ScheduleBackup from '../../pages/Settings/ScheduleBackup';
import { clearALLCache } from '../../resources/Hooks';
import { useGoogleBackup } from './useGoogleBackup';

const GoogleBackup = () => {

    const { handleClientLoad, restoreBackup, takeBackUp, signedInUser, handleSignOutClick, handleAuthClick } = useGoogleBackup()
    const [presentAlert, dissmissAlert] = useIonAlert()

    const onlineBackupRestore = () => {
        presentAlert({
            header: 'Restore Backup',
            subHeader: 'Are you sure you want to restore the backup from Google Drive?',
            message: 'Please make sure you have a backup of your data before restoring. Previous data will be lost.',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'cancel-text',
                    handler: () => {
                        dissmissAlert()
                    }
                },
                {
                    text: 'Restore',
                    cssClass: 'green-text',
                    handler: () => {
                        restoreBackup()
                        dissmissAlert()
                    }
                }
            ]
        })
    }

    const onlineBackup = () => {
        presentAlert({
            header: 'Take Online Backup',
            subHeader: 'Are you sure you want to take a backup of your data on Google Drive?',
            message: 'Backup will be saved in your Google Drive account. Previous backup will be overwritten.',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'cancel-text',
                    handler: () => {
                        dissmissAlert()
                    }
                },
                {
                    text: 'Backup Now',
                    handler: () => {
                        takeBackUp()
                        dissmissAlert()
                    }
                }
            ]
        })
    }

    useIonViewWillEnter(() => {
        handleClientLoad()
    })

    return (
        <>
            <IonItem>
                <IonLabel>Online Backup</IonLabel>
                <IonNote className='ion-padding ion-padding-top' hidden={!signedInUser}>Signed in as {signedInUser}</IonNote>
                <IonButton hidden={signedInUser} onClick={handleAuthClick}>
                    Google Signin</IonButton>
                <IonButton hidden={!signedInUser} onClick={onlineBackup}>Google Backup</IonButton>
                <IonButton hidden={!signedInUser} color='danger' onClick={handleSignOutClick}>Sign Out GDrive</IonButton>
            </IonItem>
            <IonItem>
                <IonLabel>Online Restore</IonLabel>
                <IonButton hidden={!signedInUser} onClick={onlineBackupRestore}>Google Restore</IonButton>
            </IonItem>
            <ScheduleBackup user={signedInUser} />
            <ApplicationCache />
        </>
    )
}

const ApplicationCache = () => {

    const [presentAlert , dissmissAlert] = useIonAlert()

    const clearCache = () => {
        presentAlert({
            header: 'Clear Application Cache',
            subHeader: 'Are you sure you want to clear the application cache?',
            message: 'If offline, the application will not be able to restore the appdata.',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'cancel-text',
                    handler: () => {
                        dissmissAlert()
                    }
                },
                {
                    text: 'Clear',
                    cssClass: 'red',
                    handler: () => {
                        clearALLCache().then(() => {
                            dissmissAlert()
                            window.location.reload();
                        })
                    }
                }
            ]
        })
    }
    
    return (
        <IonItem>
            <IonLabel>Clear Application Cache</IonLabel>
            <IonButton onClick={clearCache}>Clear Cache</IonButton>
        </IonItem>
    )
}


export default GoogleBackup

